/**
 * Define every MB Group custom element. Idempotent and SSR-safe: it does nothing
 * when there is no `customElements` registry, and skips any tag already defined.
 */
import { ELEMENTS } from "./elements.js";

export function registerAll(): void {
	if (typeof customElements === "undefined") return;
	for (const [tag, ctor] of Object.entries(ELEMENTS)) {
		if (!customElements.get(tag)) customElements.define(tag, ctor);
	}
}
